import React from 'react';
import { execQuery } from '../api';
import { useMethod } from '@roc-digital/ui-lib';
import { BarChart } from './BarChart';

export interface SqlLineChartProps {
  children: string;
  args?: any[];
  intColumns?: any[];
  startTime: number;
  endTime: number;
  events?: {time: string, count: number, label?: string}[];
  width?: number;
}

interface QueryResultType {time: string; count: number, label: string}

async function histogramQuery(sql: string, args: any[], ) {
  if(!sql) return [];

  return await execQuery<QueryResultType>({
    sql, args,
    intColumns: ['count']
  });
}

export function SqlLineChart(props: SqlLineChartProps) {
    const args= React.useMemo(() => {
      const sql = props.children.toString()
      .replaceAll(':startTime', props.startTime.toString())
      .replaceAll(':endTime', props.endTime.toString())
      return {
        sql: sql,
        args: props.args || []
      }
    }, [
      props.children,
      props.args,
      props.startTime,
      props.endTime,
    ]);
    
    const call = useMethod(histogramQuery, {
      autoRun: [args.sql, args.args],
    });
  
    return <BarChart
      data={call.result}
      startTime={props.startTime}
      endTime={props.endTime}
      events={props.events}
      width={props.width}
    />
}